/** @jsx jsx */
import { jsx } from '@emotion/core';
import { BannerType, Tag } from '@zapier/common-components';

type AppBannerProps = {
  banner?: BannerType;
};

const bannerColors = {
  beta: 'viper',
  'by-invite': 'steel',
  deprecated: 'steel',
  premium: 'oldManLogan',
  upcoming: 'armor',
};

const AppBanner = ({ banner }: AppBannerProps) => {
  if (!banner) {
    return null;
  }

  return (
    <Tag backgroundColor={bannerColors[banner]}>
      {banner.replace(/-/g, ' ')}
    </Tag>
  );
};

export default AppBanner;
